module.exports = __webpack_public_path__ + "static/media/status-canceled.bd0dfd80.svg";